import { ca } from '@cian/analytics';

import { IAgentSchema, IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

import { getCustomUrl } from './tracking';

export const trackBookingPaymentSucceeded = (offer: IOfferSchema, agent: IAgentSchema | null) => {
  ca('event', {
    action: 'payment_success',
    category: 'Booking',
    label: getCustomUrl(offer, agent),
    name: 'oldevent',
  });
};

export const trackBookingPaymentFailed = (offer: IOfferSchema, agent: IAgentSchema | null) => {
  ca('event', {
    action: 'payment_error',
    category: 'Booking',
    label: getCustomUrl(offer, agent),
    name: 'oldevent',
  });
};

export const getBookingTracking = (offer: IOfferSchema, agent: IAgentSchema | null) => {
  const customPageUrl = getCustomUrl(offer, agent);
  const pageType = 'Card';

  return {
    onAlreadyBookedError: () => {
      ca('event', {
        action: 'Error_alreadybooked',
        category: 'Booking',
        label: customPageUrl,
        name: 'oldevent',
      });
    },

    onBookingButtonClicked: () => {
      ca('event', {
        action: 'Actionbutton_click',
        category: 'Booking',
        label: customPageUrl,
        name: 'oldevent',
      });
    },

    onConfirmationCodeChecked: () => {
      ca('event', {
        action: 'sms_confirm',
        category: 'Booking',
        label: customPageUrl,
        name: 'oldevent',
      });
    },

    onConfirmationCodeSent: () => {
      ca('event', {
        action: 'sms_send',
        category: 'Booking',
        label: customPageUrl,
        name: 'oldevent',
      });
    },

    onLandingOpened: () => {
      ca('event', {
        action: 'Landing_open',
        category: 'Booking',
        label: pageType,
        name: 'oldevent',
      });
    },

    onPaymentRedirect: () => {
      ca('event', {
        action: 'goto_payment',
        category: 'Booking',
        label: customPageUrl,
        name: 'oldevent',
      });
    },

    onBookingPaymentFailed: () => {
      ca('event', {
        action: 'payment_error',
        category: 'Booking',
        label: customPageUrl,
        name: 'oldevent',
      });
    },
  };
};
